import React from 'react';
import { motion } from 'framer-motion';
import { Skill } from '../../types';
import AnimatedCard from './AnimatedCard';
import { Palette, Code, Sparkles } from 'lucide-react';

interface SkillCardProps {
    skill: Skill;
    index: number;
}

const SkillCard: React.FC<SkillCardProps> = ({ skill, index }) => {
    const iconMap = {
        Design: Palette,
        Website: Code,
        Other: Sparkles,
    };

    const Icon = iconMap[skill.category];

    return (
        <AnimatedCard
            hover
            glow
            className="h-full"
        >
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="space-y-4"
            >
                <div className="flex items-center space-x-3">
                    <div className="p-3 rounded-lg bg-gradient-to-br from-sky-400 to-sky-500 text-white">
                        <Icon size={24} />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900">{skill.title}</h3>
                </div>

                <p className="text-slate-600 leading-relaxed whitespace-pre-line jp-text">
                    {skill.description}
                </p>

                <div className="pt-4 flex flex-wrap gap-2">
                    {skill.tools.map((tool, toolIndex) => (
                        <motion.span
                            key={tool}
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ delay: index * 0.1 + toolIndex * 0.05 }}
                            className="px-3 py-1 text-sm font-medium text-sky-600 bg-sky-50 rounded-full border border-sky-200"
                        >
                            {tool}
                        </motion.span>
                    ))}
                </div>
            </motion.div>
        </AnimatedCard>
    );
};

export default SkillCard;